<template>
<div id="app" class="home page-template-default wp-custom-logo sticky-enabled no-sidebar separate-containers">
  <HeadNav selectedLanguage="en" page="gb" :gotodownload="goToDownload" />

  <main id="maincontent" class="home-main">
    <section class="hero-section section-band">
      <div class="section-inner hero-shell">
        <h1>GB WhatsApp Download APK Latest Version (Anti-Ban)</h1>
        <p class="hero-lede">
          Download the latest GB WhatsApp APK for Android with new features, privacy controls, and customization options.
          Get the updated version with an easy installation guide and the latest Anti-Ban improvements.
        </p>

        <div class="hero-media">
          <img src="../assets/gblogo2.webp" alt="GB WhatsApp logo" />
        </div>

        <div class="hero-action">
          <button type="button" class="primary-download" @click="goToDownload">
            <img src="@/assets/download-line.svg" alt="" class="download-icon" />
            Download GB WhatsApp APK (Free)
          </button>
        </div>

        <div class="info-table hero-file-table">
          <table>
            <tbody>
              <tr v-for="item in heroFileInfo" :key="item.label">
                <th>{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <article class="article-shell">
      <details class="toc-panel">
        <summary>Table of Contents</summary>
        <ol>
          <li><a href="#what-is">What Is GB WhatsApp APK?</a></li>
          <li><a href="#whats-new">What's New in the Latest Version of GB WhatsApp?</a></li>
          <li><a href="#latest-features">GB WhatsApp APK Latest Features</a></li>
          <li><a href="#android-download">How to Download GB WhatsApp APK for Android</a></li>
          <li><a href="#ios-download">How to Download GB WhatsApp for iOS</a></li>
          <li><a href="#update">How to Update GB WhatsApp to the Latest Version</a></li>
          <li><a href="#pc-windows">GB WhatsApp APK for PC / Windows</a></li>
          <li><a href="#comparison">GB WhatsApp vs. Official WhatsApp</a></li>
          <li><a href="#safety">Is GB WhatsApp Safe to Use?</a></li>
          <li><a href="#backup">How to Backup &amp; Restore GB WhatsApp Chats &amp; Media Files?</a></li>
          <li><a href="#problems">Common GB WhatsApp Problems &amp; Fixes</a></li>
          <li><a href="#faq">GB WhatsApp FAQ</a></li>
        </ol>
      </details>

      <section class="content-section intro-copy">
        <p>
          If you want more privacy controls, customization, and advanced messaging features,
          <a href="/"><strong>GB WhatsApp</strong></a> offers an alternative to the standard WhatsApp experience. Depending on the version,
          you can access features such as Ghost Mode, hidden blue ticks, frozen last seen, custom themes and fonts,
          message scheduling, HD media sharing, Status downloads, and multi-account support.
        </p>
        <p>
          GB WhatsApp gives you more ways to personalize your chats and manage your messaging preferences. Before installing,
          make sure you download the APK from a source you trust and use a version that is compatible with your Android device.
        </p>
      </section>

      <section id="what-is" class="content-section">
        <h2>What Is GB WhatsApp APK?</h2>
        <p>
          <a href="/"><strong>GB WhatsApp APK</strong></a> is a modified version of WhatsApp developed by independent third-party developers.
          It is designed for Android users who want an alternative WhatsApp experience with additional customization and privacy options.
        </p>
        <p>
          The basic messaging experience remains familiar to WhatsApp users, including chats, contacts, groups, media sharing,
          and voice or video communication. The main difference is that GB WhatsApp changes and expands parts of the standard app
          to give users more flexibility over how they use and personalize it.
        </p>
        <figure class="wide-image">
          <img src="@/assets/gb-whatsapp-apk.png" alt="GB WhatsApp APK overview" />
        </figure>
        <p>
          Unlike the official WhatsApp application, <strong>GB WhatsApp is not available through the Google Play Store</strong>.
          It is distributed as an APK and needs to be installed manually on a compatible Android device.
        </p>
        <p>
          Because it is a third-party application, choosing a reliable APK source is important. Before installing, check the version details,
          make sure the file is compatible with your Android device, and review the permissions requested during installation.
        </p>
        <p>
          If you are replacing or updating an existing version, creating a backup of important chats and media beforehand is recommended.
          This gives you a better chance of keeping your data available if something goes wrong during the installation process.
        </p>
      </section>

      <section id="whats-new" class="content-section">
        <h2>What's New in the Latest Version of GB WhatsApp?</h2>
        <p>
          The latest <strong>GB WhatsApp update</strong> brings several improvements aimed at giving users more control over privacy,
          appearance, and everyday messaging. This version also focuses on improving stability and addressing issues found in earlier builds.
        </p>
        <ul class="bullet-list">
          <li v-for="item in newFeatures" :key="item.title">
            <strong>{{ item.title }}:</strong> {{ item.text }}
          </li>
        </ul>
      </section>

      <section id="latest-features" class="content-section">
        <h2>GB WhatsApp APK Latest Features</h2>
        <p>
          GB WhatsApp APK adds a wider range of customization, privacy, and messaging controls compared with the standard WhatsApp experience.
          The latest build continues to focus on giving users more control over how chats, notifications, media, and their online presence are managed.
          Commonly highlighted features include custom themes, enhanced privacy settings, anti-delete options, automatic replies,
          and expanded media-sharing capabilities.
        </p>

        <div class="feature-grid">
          <section v-for="feature in featureCards" :key="feature.title" class="feature-card">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.text }}</p>
          </section>
        </div>

        <p class="footnote">
          Because GB WhatsApp is a third-party modification rather than an official WhatsApp release, available features can vary between versions.
          Users should check the feature list of the specific APK build before updating or installing it.
        </p>
      </section>

      <section id="android-download" class="content-section">
        <h2>How to Download GB WhatsApp APK for Android</h2>
        <p>
          GB WhatsApp is distributed as an APK rather than through the Google Play Store, so Android users need to download the installation file
          and install it manually. Since it is an unofficial modified version of WhatsApp, make sure you use a trustworthy source and check the APK before installing it.
        </p>

        <h3>Steps to Download GB WhatsApp APK</h3>
        <ol class="steps-list download-steps">
          <li v-for="(step, index) in androidSteps" :key="step.title">
            <div class="step-heading">
              <span class="step-number">{{ index + 1 }}</span>
              <strong>{{ step.title }}</strong>
            </div>
            <p>{{ step.text }}</p>
          </li>
        </ol>

        <h3>Important Things to Check Before Installation</h3>
        <p>
          Because GB WhatsApp is developed by third parties and is not an official WhatsApp client, it carries additional security, privacy,
          and account-restriction considerations. WhatsApp may also restrict accounts that use unofficial clients.
        </p>
        <p>
          For this reason, avoid modified APK files from unknown sources, scan downloaded files when possible, and keep a backup of important
          conversations before replacing or updating your existing WhatsApp installation.
        </p>

        <h3>System Requirements</h3>
        <div class="info-table">
          <table>
            <tbody>
              <tr v-for="item in systemRequirements" :key="item.label">
                <th>{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          GB WhatsApp isn't on the Google Play Store, so you'll need the APK file from a reliable source.
          Always take the latest build for the current features and up-to-date anti-ban measures.
        </p>
      </section>

      <section id="ios-download" class="content-section">
        <h2>How to Download GB WhatsApp for iOS</h2>
        <p>
          GB WhatsApp is primarily developed as an Android APK, so there is no official iOS version available through the Apple App Store.
          If you are using an iPhone, follow these steps:
        </p>
        <ol class="steps-list download-steps">
          <li v-for="(step, index) in iosSteps" :key="step.title">
            <div class="step-heading">
              <span class="step-number">{{ index + 1 }}</span>
              <strong>{{ step.title }}</strong>
            </div>
            <p>{{ step.text }}</p>
          </li>
        </ol>
      </section>

      <section id="update" class="content-section">
        <h2>How to Update GB WhatsApp to the Latest Version</h2>
        <p>
          Keeping GB WhatsApp updated can give you access to newer features, bug fixes, and performance improvements.
          Since GB WhatsApp is a modified Android application, updates are usually installed manually using the latest APK.
        </p>
        <ol class="steps-list download-steps">
          <li v-for="(step, index) in updateSteps" :key="step.title">
            <div class="step-heading">
              <span class="step-number">{{ index + 1 }}</span>
              <strong>{{ step.title }}</strong>
            </div>
            <p>{{ step.text }}</p>
          </li>
        </ol>
      </section>

      <section id="pc-windows" class="content-section">
        <h2>GB WhatsApp APK for PC / Windows</h2>
        <p>
          GB WhatsApp does not have a native Windows or Mac version. It is distributed as an Android APK, which means the app cannot be installed
          directly on a desktop computer like a regular Windows application.
        </p>
        <p>
          To run GB WhatsApp on a PC, you can use an Android emulator. The emulator provides a virtual Android environment where you can install
          and open the APK. The overall setup is different from installing the app on a phone, and the experience may vary depending on your computer's
          processor, RAM, and available storage.
        </p>
      </section>

      <section id="comparison" class="content-section">
        <h2>GB WhatsApp vs. Official WhatsApp</h2>
        <p>
          GB WhatsApp and the official WhatsApp app offer the same basic messaging experience, but they differ in customization, privacy controls,
          updates, and security. GB WhatsApp adds extra settings and interface options, while the official WhatsApp app focuses on stability,
          security, and support from WhatsApp.
        </p>
        <div class="comparison-table">
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>GB WhatsApp</th>
                <th>Official WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in comparisonRows" :key="row.feature">
                <th>{{ row.feature }}</th>
                <td>{{ row.gb }}</td>
                <td>{{ row.official }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section id="safety" class="content-section">
        <h2>Is GB WhatsApp Safe to Use?</h2>
        <p>
          GB WhatsApp is a third-party modified app, so it carries some risks that the official WhatsApp does not.
          The biggest concern is downloading a fake or modified APK from an unreliable source.
        </p>
        <p>
          There is also a risk of account restrictions because GB WhatsApp is not an official WhatsApp client.
          Anti-Ban features may reduce the risk, but they cannot guarantee that your account will not be suspended.
        </p>
        <p>
          If you decide to use GB WhatsApp, download the APK from a trusted source, check the file before installation,
          and avoid sharing sensitive information through the app.
        </p>

        <h3>How to Use GB WhatsApp Safely</h3>
        <ol class="safe-tips">
          <li v-for="(tip, index) in safeTips" :key="`safe-tip-${index}`">
            <template v-for="(part, partIndex) in tip.parts">
              <strong v-if="part.bold" :key="partIndex">{{ part.bold }}</strong>
              <span v-else :key="partIndex">{{ part.text }}</span>
            </template>
          </li>
        </ol>
      </section>

      <section id="backup" class="content-section">
        <h2>How to Backup &amp; Restore GB WhatsApp Chats &amp; Media Files?</h2>
        <p>
          Backing up your GB WhatsApp chats and media can help prevent important conversations, photos, and videos from being lost
          when updating or reinstalling the app.
        </p>

        <h3>How to Backup GB WhatsApp</h3>
        <ol class="steps-list download-steps">
          <li v-for="(step, index) in backupSteps" :key="step">
            <div class="step-heading">
              <span class="step-number">{{ index + 1 }}</span>
              <span>{{ step }}</span>
            </div>
          </li>
        </ol>

        <h3>How to Restore GB WhatsApp</h3>
        <ol class="steps-list download-steps">
          <li v-for="(step, index) in restoreSteps" :key="step">
            <div class="step-heading">
              <span class="step-number">{{ index + 1 }}</span>
              <span>{{ step }}</span>
            </div>
          </li>
        </ol>

        <p>
          It is a good idea to create a fresh backup before updating, uninstalling, or moving GB WhatsApp to another device.
          Backup and restore options may vary between different GB WhatsApp builds.
        </p>
      </section>

      <section id="problems" class="content-section">
        <h2>Common GB WhatsApp Problems &amp; Fixes</h2>
        <div class="problem-list">
          <section v-for="problem in commonProblems" :key="problem.title" class="problem-item">
            <h3>{{ problem.title }}</h3>
            <p>{{ problem.fix }}</p>
          </section>
        </div>
      </section>

      <section id="faq" class="content-section faq-section">
        <h2>GB WhatsApp FAQ</h2>
        <div class="faq-list">
          <details v-for="item in faqs" :key="item.question" class="faq-item">
            <summary>{{ item.question }}</summary>
            <div class="faq-answer">
              <p>{{ item.answer }}</p>
            </div>
          </details>
        </div>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

const DEFAULT_DOMAIN = 'gbwtsapp.com';
const DEFAULT_APP_NAME = 'GB_gbwtsapp.com';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      heroFileInfo: [
        { label: 'App Name', value: 'GB WhatsApp' },
        { label: 'Version', value: 'v18.80' },
        { label: 'Size', value: '98 MB' },
        { label: 'OS', value: 'Android' },
        { label: 'Developer', value: 'AlexMods' },
        { label: 'Provided by', value: 'gbwtsapp.com' },
        { label: 'Downloads', value: '10 Million+' },
        { label: 'Last Updated', value: 'Sep 2026' },
      ],
      newFeatures: [
        {
          title: 'Improved Anti-Ban Protection',
          text: 'The latest build includes updated anti-ban measures designed to improve account stability and reduce the likelihood of restrictions.',
        },
        {
          title: 'Ghost Mode',
          text: 'Ghost Mode brings several privacy options together, allowing you to hide your online status, freeze your last seen, and read messages without automatically sending read receipts.',
        },
        {
          title: 'Flexible Status Duration',
          text: 'You can now choose how long your status remains visible, with options such as 24 hours, 3 days, or 1 week.',
        },
        {
          title: 'Updated Settings Interface',
          text: 'The settings menu has been redesigned with a cleaner layout. Users who prefer the previous interface can still switch back to the classic GB WhatsApp style.',
        },
        {
          title: 'Quick Light and Dark Mode',
          text: 'A new shortcut makes it easier to switch between light and dark themes directly from the main screen.',
        },
        {
          title: 'Message Edit History',
          text: 'When a message has been edited, you can check its previous version alongside the updated text for easier reference.',
        },
        {
          title: 'Performance and Bug Fixes',
          text: 'The update also addresses various bugs, crashes, and performance problems reported in earlier versions, helping the app run more smoothly.',
        },
      ],
      featureCards: [
        {
          title: 'Advanced Privacy Controls',
          text: 'Privacy settings are one of the main reasons users choose GB WhatsApp. Depending on the build, users can hide their online status, last seen, blue ticks, typing indicators, and other activity indicators. These options make it easier to control which parts of your messaging activity are visible to other contacts.',
        },
        {
          title: 'Custom Themes and Interface',
          text: 'GB WhatsApp provides additional customization options for the app interface. Users can change themes, fonts, colors, chat backgrounds, and other visual elements to create a more personalized messaging environment.',
        },
        {
          title: 'Anti-Delete Messages',
          text: 'The anti-delete feature can keep certain messages visible even after the sender removes them from a conversation. This can be useful when you need to refer back to a message that was deleted after being sent.',
        },
        {
          title: 'Auto Reply and Message Scheduling',
          text: 'Built-in automation tools allow users to configure automatic replies and schedule messages. These features can be useful for responding when you are unavailable or preparing messages to be sent at a specific time.',
        },
        {
          title: 'Larger Media Sharing',
          text: 'Some GB WhatsApp builds support larger files and expanded media-sharing limits compared with the standard app. Users may also get additional controls for image and video quality when sending media.',
        },
        {
          title: 'Dual Account Support',
          text: 'GB WhatsApp can allow two WhatsApp accounts to be used on the same Android device, provided each account uses a different phone number. This can be convenient for users who want to separate personal and work conversations.',
        },
        {
          title: 'DND Mode',
          text: 'DND mode gives users an option to temporarily stop WhatsApp notifications or network activity while using other applications. It can help reduce interruptions when you do not want incoming messages to disturb you.',
        },
        {
          title: 'Improved Messaging Controls',
          text: 'Additional options such as message filtering, chat management, broadcast tools, unread-message controls, and notification customization give users more flexibility when managing conversations.',
        },
      ],
      androidSteps: [
        {
          title: 'Download the APK file',
          text: 'Visit the GB WhatsApp download page and tap the download button to save the latest APK file to your Android phone. Before downloading, check the version number, file size, and Android requirements.',
        },
        {
          title: 'Allow APK installation',
          text: 'If your phone blocks the installation, open Settings and look for the security or app-installation settings. Allow your browser or file manager to install apps from that source.',
        },
        {
          title: 'Install GB WhatsApp',
          text: 'Open your Downloads folder, locate the GB WhatsApp APK file, and tap it to start the installation. Follow the on-screen instructions until the process is complete.',
        },
        {
          title: 'Open and set up the app',
          text: 'After installation, launch GB WhatsApp and enter your phone number to complete the initial setup. If you are moving from another WhatsApp installation, back up important chats and media beforehand.',
        },
      ],
      iosSteps: [
        {
          title: 'Check iOS Compatibility',
          text: 'Confirm whether the specific GB WhatsApp build supports iOS before attempting installation.',
        },
        {
          title: 'Avoid Untrusted Downloads',
          text: 'Do not install unknown configuration profiles, certificates, or modified apps from suspicious websites.',
        },
        {
          title: 'Use Official WhatsApp on iPhone',
          text: 'For a reliable iOS experience, download WhatsApp from the Apple App Store.',
        },
        {
          title: 'Sign In and Verify Your Number',
          text: 'Open WhatsApp on your iPhone and complete phone-number verification.',
        },
        {
          title: 'Restore Your Backup',
          text: 'If an iCloud backup is available, restore your chats and media during setup.',
        },
        {
          title: 'Start Messaging',
          text: 'Once setup is complete, you can use WhatsApp normally on your iPhone.',
        },
      ],
      updateSteps: [
        {
          title: 'Check Your Current Version',
          text: 'Open GB WhatsApp and check the version number in the app settings.',
        },
        {
          title: 'Download the Latest APK',
          text: 'Get the newest GB WhatsApp APK from a trusted source and make sure the version is compatible with your Android device.',
        },
        {
          title: 'Back Up Your Chats',
          text: 'Create a backup of your important conversations and media before starting the update.',
        },
        {
          title: 'Open the New APK',
          text: 'Locate the downloaded APK file on your device and tap it to start the installation.',
        },
        {
          title: 'Install the Update',
          text: 'Follow the on-screen instructions. If prompted, allow APK installation from the relevant source in your Android settings.',
        },
        {
          title: 'Open GB WhatsApp',
          text: 'Once the update is complete, launch the app and check that your chats and account information are still available.',
        },
        {
          title: 'Check the New Features',
          text: 'Visit the settings menu to see which new privacy, customization, and messaging features have been added in the latest version.',
        },
      ],
      systemRequirements: [
        { label: 'Android version', value: 'Android 5.0 or higher' },
        { label: 'Storage space', value: 'Minimum 150 MB free' },
        { label: 'RAM', value: '1 GB or higher' },
        { label: 'Internet connection', value: 'Required for verification' },
        { label: 'Unknown sources', value: 'Must be enabled in settings' },
      ],
      comparisonRows: [
        {
          feature: 'Messaging & Calls',
          gb: '✓',
          official: '✓',
        },
        {
          feature: 'Custom Themes',
          gb: '✓',
          official: 'Limited',
        },
        {
          feature: 'Advanced Privacy Controls',
          gb: '✓',
          official: 'Limited',
        },
        {
          feature: 'Anti-Delete Options',
          gb: '✓',
          official: 'Limited',
        },
        {
          feature: 'Auto Reply',
          gb: '✓',
          official: 'Limited',
        },
        {
          feature: 'Message Scheduling',
          gb: '✓',
          official: 'Limited',
        },
        {
          feature: 'Official App Store Support',
          gb: '✗',
          official: '✓',
        },
        {
          feature: 'Automatic Updates',
          gb: 'Limited',
          official: '✓',
        },
        {
          feature: 'Official WhatsApp Support',
          gb: '✗',
          official: '✓',
        },
        {
          feature: 'Account Restriction Risk',
          gb: 'Higher',
          official: 'Lower',
        },
      ],
      safeTips: [
        {
          parts: [
            { bold: 'Download from a trusted source' },
            { text: ': and check the ' },
            { bold: 'APK' },
            { text: ' before installing.' },
          ],
        },
        {
          parts: [
            { bold: 'Keep GB WhatsApp updated' },
            { text: ': to get the latest fixes and improvements.' },
          ],
        },
        {
          parts: [
            { bold: 'Enable two-step verification' },
            { text: ': to add extra protection to your ' },
            { bold: 'account' },
            { text: '.' },
          ],
        },
        {
          parts: [
            { bold: 'Consider using a secondary number' },
            { text: ': if you are concerned about ' },
            { bold: 'account restrictions' },
            { text: '.' },
          ],
        },
        {
          parts: [
            { bold: 'Back up your chats regularly' },
            { text: ': so you do not lose ' },
            { bold: 'important conversations' },
            { text: '.' },
          ],
        },
        {
          parts: [
            { bold: 'Avoid spam and bulk messaging' },
            { text: ': which may increase the chance of ' },
            { bold: 'account restrictions' },
            { text: '.' },
          ],
        },
        {
          parts: [
            { bold: 'Review app permissions' },
            { text: ': and avoid granting ' },
            { bold: 'access' },
            { text: ' that ' },
            { bold: 'GB WhatsApp' },
            { text: ' does not need.' },
          ],
        },
      ],
      backupSteps: [
        'Open GB WhatsApp and go to Settings.',
        'Tap Chats and select Chat Backup.',
        'Choose the available backup option and start the backup.',
        'Wait until the backup process is completed.',
      ],
      restoreSteps: [
        'Install GB WhatsApp on your Android device.',
        'Open the app and verify the same phone number used for your backup.',
        'Allow the app to access your backup files when prompted.',
        'Select Restore if a compatible backup is detected.',
        'Wait for your chats and media files to finish restoring.',
      ],
      commonProblems: [
        {
          title: 'GB WhatsApp Is Not Installing',
          fix: 'Check that your Android device has enough storage and that the APK is compatible with your Android version. You may also need to allow installation from the source where the APK was downloaded.',
        },
        {
          title: 'GB WhatsApp Keeps Crashing',
          fix: 'Try restarting your phone, clearing the app cache, or installing the latest compatible version. An outdated or damaged APK can also cause frequent crashes.',
        },
        {
          title: 'GB WhatsApp Is Not Updating',
          fix: 'Download the latest APK and install it over your existing version. Before updating, create a backup of your important chats and media.',
        },
        {
          title: 'GB WhatsApp Backup Is Not Showing',
          fix: 'Make sure the backup files are stored in the correct folder and that you are using the same phone number. Local backups may need to be moved to the appropriate GB WhatsApp folder before restoration.',
        },
        {
          title: 'GB WhatsApp Cannot Verify My Number',
          fix: 'Check your internet connection and make sure the phone number is entered correctly. If verification repeatedly fails, wait before requesting another verification code.',
        },
        {
          title: 'GB WhatsApp Messages Are Not Sending',
          fix: 'Check your internet connection first. If other apps can access the internet normally, restart GB WhatsApp and make sure you are using a supported version.',
        },
        {
          title: 'GB WhatsApp Notifications Are Not Working',
          fix: 'Check Android notification permissions and battery restrictions for GB WhatsApp. Make sure background activity is allowed if you want to receive messages promptly.',
        },
        {
          title: 'GB WhatsApp Account Is Banned',
          fix: 'An account restriction can occur when using an unofficial WhatsApp client. There is no guaranteed anti-ban method, so users should follow WhatsApp account policies and consider switching to the official app if the restriction continues.',
        },
        {
          title: 'GB WhatsApp Is Taking Too Much Storage',
          fix: 'Large videos, images, status files, and chat media can quickly use storage space. Remove unnecessary media and clear cached files to free up space.',
        },
      ],
      faqs: [
        {
          question: 'How Do I Hide My Online Status in GB WhatsApp?',
          answer: 'Open GB WhatsApp Settings > Privacy and look for the online status option. Depending on the version, you can choose who can see when you are online.',
        },
        {
          question: 'How Do I Hide Blue Ticks in GB WhatsApp?',
          answer: 'Go to Privacy Settings and adjust the read-receipt or blue-tick option. You can usually control whether other contacts can see that you have read their messages.',
        },
        {
          question: 'How Do I Hide the Typing Status?',
          answer: 'Open the privacy settings and find the Typing Indicator option. Turn it off if you do not want contacts to see when you are typing.',
        },
        {
          question: 'How Do I Enable Ghost Mode?',
          answer: 'Open the GB WhatsApp privacy settings and select Ghost Mode if it is available in your version. This can combine several privacy controls in one setting.',
        },
        {
          question: 'How Do I Change the GB WhatsApp Theme?',
          answer: 'Go to Settings > Themes and choose a theme from the available options. Some versions also allow you to customize colors, fonts, wallpapers, and other interface elements.',
        },
        {
          question: 'How Do I Enable Dark Mode?',
          answer: 'Open GB WhatsApp settings and select Theme or Display. Choose Dark Mode to switch the interface to a darker appearance.',
        },
        {
          question: 'How Do I Stop Others From Deleting Messages?',
          answer: 'If your version includes Anti-Delete Messages, open the relevant privacy settings and enable the feature. Availability and settings can differ between builds.',
        },
        {
          question: 'How Do I Download WhatsApp Statuses?',
          answer: 'Open the status section and select the status you want to save. Some GB WhatsApp versions include a built-in Status Downloader for saving photos and videos.',
        },
        {
          question: 'How Do I Set an Auto Reply?',
          answer: 'Go to the Auto Reply section in GB WhatsApp settings, create your reply message, and choose when or who should receive the automatic response.',
        },
        {
          question: 'How Do I Schedule a Message?',
          answer: 'If your version supports Message Scheduler, open the scheduler, select a contact, enter your message, and choose the date and time for delivery.',
        },
        {
          question: 'How Do I Hide a Chat?',
          answer: 'Depending on the GB WhatsApp version, you can use available chat privacy or lock options to keep selected conversations away from the main chat list.',
        },
        {
          question: 'How Do I Customize Notifications?',
          answer: 'Open Settings > Notifications to adjust notification sounds, vibration, pop-ups, and other available notification options.',
        },
        {
          question: 'How Do I Stop GB WhatsApp From Automatically Downloading Media?',
          answer: 'Open Settings > Storage and Data and adjust the media auto-download options. You can choose which types of media are downloaded automatically.',
        },
        {
          question: 'How Do I Freeze My Last Seen?',
          answer: 'Open the Privacy settings and select the Last Seen option. If your version supports freezing the last seen, enable the corresponding setting.',
        },
        {
          question: 'Can I Use Two WhatsApp Accounts on One Phone?',
          answer: 'GB WhatsApp versions may support multiple accounts or can be installed alongside another WhatsApp application. However, support depends on the Android device and the specific build you are using.',
        },
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK;
        })
        .catch(() => {
          this.apk = process.env.VUE_APP_GBLINK;
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DEFAULT_DOMAIN,
          appName: appname || DEFAULT_APP_NAME,
        })
        .then((res) => {
          if (res.code == 200 && type == 1) {
            this.apk = res.data.apk;
          }
        })
        .catch(() => {
          if (type == 1) {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goToDownload() {
      this.$router.push({
        name: 'en-download',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-main {
  background: #f6f8f7;
  color: #24312c;
}

.section-inner,
.article-shell {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;
}

.hero-section {
  background:
    radial-gradient(circle at 8% 15%, rgba(255, 199, 83, 0.18), transparent 28%),
    linear-gradient(135deg, #f7fff9 0%, #e8f5ef 52%, #fff7e1 100%);
  border-bottom: 1px solid #dbe8e1;
}

.hero-shell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 42px;
}

h1 {
  margin: 0 0 18px;
  color: #10261d;
  font-size: 46px;
  font-weight: 800;
  line-height: 1.08;
  text-align: center;
}

.hero-lede {
  max-width: 820px;
  margin: 0 0 26px;
  color: #40544c;
  font-size: 18px;
  line-height: 1.7;
  text-align: center;
}

.hero-media {
  width: min(160px, 58vw);
  margin-bottom: 24px;
}

.hero-media img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0;
  box-shadow: none;
}

.hero-action {
  width: 100%;
  max-width: 390px;
  margin-bottom: 24px;
}

.primary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 54px;
  padding: 0 26px;
  border: 0;
  border-radius: 8px;
  background: #128c62;
  color: #fff;
  font-size: 17px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(18, 140, 98, 0.24);
}

.primary-download:hover {
  background: #0e7451;
}

.download-icon {
  width: 23px;
  height: 23px;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

.hero-file-table {
  width: min(760px, 100%);
}

.article-shell {
  padding: 34px 0 60px;
}

.toc-panel {
  margin-bottom: 24px;
  border: 1px solid #dbe8e1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.toc-panel summary {
  padding: 16px 18px;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}

.toc-panel ol {
  margin: 0;
  padding: 0 20px 18px 42px;
  color: #40544c;
  font-size: 15px;
  line-height: 1.65;
}

.toc-panel a {
  color: #107b59;
  font-weight: 700;
  text-decoration: none;
}

.content-section {
  padding: 28px 0;
  border-bottom: 1px solid #dde8e2;
}

.content-section:last-child {
  border-bottom: 0;
}

.content-section h2 {
  margin: 0 0 16px;
  color: #15372a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
}

.content-section h3 {
  margin: 24px 0 10px;
  color: #1b3a2e;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.content-section p {
  margin: 0 0 16px;
  color: #40544c;
  font-size: 17px;
  line-height: 1.72;
}

.wide-image {
  width: min(720px, 86%);
  margin: 18px auto;
}

.wide-image img {
  display: block;
  width: 100%;
  border-radius: 8px;
}

.info-table,
.comparison-table {
  overflow-x: auto;
  margin: 14px 0 16px;
  border: 1px solid #d6e4dd;
  border-radius: 6px;
  background: #fff;
}

.info-table table,
.comparison-table table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td,
.comparison-table th,
.comparison-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e8eeeb;
  color: #3d4f48;
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.45;
}

.info-table tr:last-child th,
.info-table tr:last-child td,
.comparison-table tr:last-child th,
.comparison-table tr:last-child td {
  border-bottom: 0;
}

.info-table th {
  width: 32%;
  background: #eef7f2;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.comparison-table thead th {
  background: #eef7f2;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.comparison-table tbody th {
  width: 28%;
  background: #f6faf8;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.bullet-list {
  margin: 14px 0 16px 22px;
  padding: 0;
  list-style: disc;
}

.bullet-list li {
  margin-bottom: 10px;
  color: #40544c;
  font-size: 16px;
  line-height: 1.66;
}

.bullet-list strong {
  color: #15372a;
  font-weight: 800;
}

.safe-tips {
  margin: 14px 0 16px 24px;
  padding: 0;
  list-style: decimal;
}

.safe-tips li {
  margin-bottom: 10px;
  color: #40544c;
  font-size: 16px;
  line-height: 1.66;
}

.safe-tips strong {
  color: #15372a;
  font-weight: 800;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.feature-card {
  padding: 16px 18px;
  border: 1px solid #dbe8e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.feature-card h3 {
  margin: 0 0 8px;
  color: #15372a;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.35;
}

.feature-card p {
  margin: 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.6;
}

.content-section .footnote {
  margin-top: 32px;
  margin-bottom: 0;
  color: #5d6f68;
  font-size: 14px;
  line-height: 1.7;
}

.steps-list {
  margin: 14px 0 18px;
  padding: 0;
  list-style: none;
}

.download-steps {
  margin-left: 0 !important;
  list-style: none !important;
  list-style-type: none !important;
}

.download-steps .step-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}

.download-steps .step-number {
  display: inline-flex;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #128c62;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
}

.steps-list li {
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid #e2ebe6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.steps-list strong {
  color: #15372a;
  font-weight: 800;
}

.steps-list p {
  margin: 6px 0 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.55;
}

.problem-list,
.faq-list {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.problem-item,
.faq-item {
  padding: 14px 16px;
  border: 1px solid #e2ebe6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.problem-item h3 {
  margin: 0 0 6px;
  color: #15372a;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.35;
}

.problem-item p,
.faq-answer p {
  margin: 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.6;
}

.faq-item summary {
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  cursor: pointer;
}

.faq-answer {
  margin-top: 10px;
}

@media (max-width: 860px) {
  h1 {
    font-size: 36px !important;
  }

  h2 {
    font-size: 26px !important;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }

  .hero-shell {
    padding-top: 34px;
  }
}

@media (max-width: 520px) {
  .section-inner,
  .article-shell {
    padding-left: 20px;
    padding-right: 20px;
  }

  .hero-shell {
    padding-bottom: 32px;
  }

  .hero-lede {
    font-size: 16px;
  }

  .primary-download {
    width: 100%;
    padding: 0 12px;
    font-size: 15px;
  }

  .content-section h2 {
    font-size: 24px !important;
  }

  .info-table th,
  .info-table td,
  .comparison-table th,
  .comparison-table td {
    padding: 7px 10px;
    font-size: 13px;
    line-height: 1.4;
  }
}
</style>
